import { NavigationGuardNext, Route } from 'vue-router';
import { LIST_ID_BOOK_QUESTION_FOR_PERMISSION } from '@/constant/ListIdsBookQuestion';
import { LIST_PERMISSION } from '@/constant/ListPermission';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';
import store from '@/store';
import Permission from './index';

function hasPermission(idQuestion: number) {
  const PermissionClass = new Permission();

  return PermissionClass.can(LIST_ID_BOOK_QUESTION_FOR_PERMISSION[idQuestion]);
}

export function permissionPageExam(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const idExam = to?.params?.idExam;
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;
  const hasAccess = hasPermission(Number(idExam)) || isPlanFree;
  if (hasAccess) {
    next();
    return;
  }
  if (to.query && to.query.isFree) {
    next({
      name: 'Exams',
      query: { isFree: 'true' }
    });
    return;
  }
  next({
    name: 'Exams'
  });
}

export function permissionExams(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
  const PermissionClass = new Permission();

  // const isHighSchool = PermissionClass.can(LIST_PERMISSION.BOOKS_DEGREE_HIGH_SCHOOL);
  const isExams = PermissionClass.can(LIST_PERMISSION.EXAMS);
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  const hasAccess = isExams || isPlanFree;

  if (hasAccess) {
    next();
    return;
  }

  next({ name: 'Dashboard' });
}
